const QueryKeys = {
  user: 'user',
  users: 'users',
  'datapoints-search': 'datapoints-search',
  'widget-config': 'widget-config',
  'widget-config-internal': 'widget-config-internal',
  siteMeta: 'site-meta',
  groups: 'groups',
  events: 'events',
  'user-groups': 'user-groups',
  'default-stack': 'default-stack',
  masterTracker: 'master-tracker',
  trackers: 'trackers',
  controlModeTemplates: 'control-mode-templates',
  controllerLockMode: 'control-lock-mode',
  stacks: 'stacks',
  notes: 'notes',
  auditLogs: 'audit-logs',
  alerts: 'alerts',
  alertConfigs: 'alert-configs',
  pointConfigs: 'point-configs',
  pointConfigsFiltered: 'point-configs-filtered',
  widgets: 'widgets',
  devices: 'devices',
  distinctDeviceIds: 'distinct-device-ids',
  devicesParents: 'devices-parents',
  deviceTypes: 'device-types',
  devicesFiltered: 'devicesFiltered',
  parentControllers: 'parent-controllers',
};

export default QueryKeys;
